export const maritalStatuses = [
  { description:'Single', value:'Single'},
  { description: 'Married', value: 'Married' },
  { description: 'Divorced', value: 'Divorced' },
  { description: 'Widowed', value: 'Widowed' },
  { description: 'Separated', value: 'Separated' },
];
